var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15699_222357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0.62207C4.02528 0.62207 0 4.59699 0 9.50869C0 14.4207 4.02564 18.3953 9 18.3953C13.9747 18.3953 18 14.4204 18 9.50869C18 4.59665 13.9743 0.62207 9 0.62207ZM9 17.0068C4.80259 17.0068 1.40625 13.6529 1.40625 9.50869C1.40625 5.36416 4.80287 2.01061 9 2.01061C13.1974 2.01061 16.5938 5.36444 16.5938 9.50869C16.5938 13.6532 13.1971 17.0068 9 17.0068Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35156 5.0957H6.89062C6.50229 5.0957 6.1875 5.40653 6.1875 5.78997C6.1875 6.17341 6.50229 6.48424 6.89062 6.48424H9.35156C9.93312 6.48424 10.4062 6.95141 10.4062 7.52564C10.4062 8.09987 9.93312 8.56704 9.35156 8.56704H8.64844C8.2601 8.56704 7.94531 8.87786 7.94531 9.26131V10.2608C7.94531 10.6442 8.2601 10.955 8.64844 10.955C9.03677 10.955 9.35156 10.6442 9.35156 10.2608V9.95557C10.7085 9.95557 11.8125 8.86551 11.8125 7.52564C11.8125 6.18577 10.7085 5.0957 9.35156 5.0957Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64844 13.6802C9.17268 13.6802 9.59766 13.2606 9.59766 12.7429C9.59766 12.2253 9.17268 11.8057 8.64844 11.8057C8.1242 11.8057 7.69922 12.2253 7.69922 12.7429C7.69922 13.2606 8.1242 13.6802 8.64844 13.6802Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15699_222357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.7732,
    fill: "white",
    transform: "translate(0 0.62207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.71c99344b0cca1bcf8dcd2591a1eccb4.svg";
export { ForwardRef as ReactComponent };